import React, { useContext } from 'react';
import classnames from 'classnames';
import IntegrationImage, { integrationImageById } from 'assets/img/integrations';
import { ChromeContext } from 'services/chrome/chromeBridge';
import { tabIsOpen } from 'services/chrome/utils';
import { observer } from 'mobx-react';
import { specialIntegrationImageType } from 'helpers/constants';
import chromeLogo from 'assets/icons/integration_icons/chrome.png';
import styles from './ItemIntegrationIcons.module.scss';

interface ItemIntegrationIconProps {
  className: string;
  itemIntegrationName: string;
  baseUrl: string;
}

export const ItemIntegrationIcons: React.FC<ItemIntegrationIconProps> = ({
  className,
  itemIntegrationName,
  baseUrl,
}) => {
  let integrationIcon: any = '';

  if (itemIntegrationName === 'google_drive') {
    integrationIcon = integrationImageById(
      itemIntegrationName,
      IntegrationImage,
      false,
      styles.icon,
      specialIntegrationImageType.provider
    );
  } else {
    integrationIcon = integrationImageById(
      itemIntegrationName,
      IntegrationImage,
      true,
      styles.icon
    );
  }

  return (
    <div className={classnames(styles.container, className)}>
      <OpenInChrome baseUrl={baseUrl} />
      {integrationIcon ? integrationIcon : <div className={styles.noIcon}></div>}
    </div>
  );
};

interface OpenInChromeProps {
  baseUrl: string;
}

const OpenInChrome: React.FC<OpenInChromeProps> = observer(({ baseUrl }) => {
  const chromeBridge = useContext(ChromeContext);

  if (tabIsOpen(chromeBridge, baseUrl)) {
    return <img alt="" className={styles.icon} src={chromeLogo} />;
  } else {
    return null;
  }
});
